const getMTDYTDClientRRGoalsAPI = (clientId, timezoneOffset) =>
  `api/goals/client/${clientId}?timezoneOffset=${timezoneOffset}`;

const createClientGoalForBonusAPI = (clientId) => `api/goals/client/${clientId}`;

const updateClientGoalForBonusAPI = (clientId, goalId) => `api/goals/client/${clientId}/${goalId}`;

export const goalsEndpoints = {
  getMTDYTDClientRRGoalsAPI,
  createClientGoalForBonusAPI,
  updateClientGoalForBonusAPI,
};
